import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Constants from "../../../../common/CustomerConstants";
import ERFDetail from "./ERFDetail";
import WorkflowApproveReject from "../../../../Components/Workflow/WorkflowApproveReject";

const ERFDetailWorkFlow = () => {
  const navigate = useNavigate();

  // Workflow-specific Redux state
  const workflow = useSelector(
    (state) => state?.purchasing?.purchase_order?.workflowPO,
  );
  const documentNumber = useSelector(
    (state) => state?.customer?.equipmentRentForm?.documentNumber,
  );

  // Redirect if no document loaded
  useEffect(() => {
    if (!documentNumber) {
      navigate(Constants.CUSTOMER_V5_MR_ERF_LIST);
    }
  }, [documentNumber, navigate]);

  // Build the same merged object the original file used
  const updatedWorkflowRecord = workflow
    ? {
        ...workflow,
        workflow_record: {
          ...workflow.workflow_record,
        },
      }
    : null;

  const workflowTop = updatedWorkflowRecord ? (
    <Row>
      <Col sm={12} lg={12} md={12}>
        <WorkflowApproveReject workflowData={updatedWorkflowRecord} />
      </Col>
    </Row>
  ) : null;

  return (
    <ERFDetail
      showEditButtons={false}
      showStoreSection={false}
      topSlot={workflowTop}
    />
  );
};

export default ERFDetailWorkFlow;